import { Box, Typography, IconButton, Tooltip, useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import RoleBasedAccess from "../../services/RoleBasedAccess";
import { downloadFilesAsync } from "../../services/FileDownloader";
import { useAsset } from "../../context/AssetContext";

const AssetHeader: React.FC = () => {
  const theme = useTheme();
  const { asset, openEditAssetIdModal, openEditAssetModal } = useAsset();

  if (!asset) return null

  return (
    <Box
      sx={{
        position: "relative",
        borderBottom: `solid 5px ${theme.palette.divider}`,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', // Center the main content
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h4">
          {asset.vin}
        </Typography>
        <RoleBasedAccess allowedRoles={["Admin", "Support"]}>
          <Tooltip title="Edit Asset ID">
            <IconButton onClick={openEditAssetIdModal}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </RoleBasedAccess>
      </Box>

      <Box
        sx={{
          position: "absolute",
          right: 16,
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
      >
        <RoleBasedAccess allowedRoles={["Admin", "Support", "Auditor"]}>
          <Tooltip title="Edit Vehicle">
            <IconButton
              sx={{ backgroundColor: theme.palette.primary.main }}
              onClick={openEditAssetModal}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </RoleBasedAccess>

        <Tooltip title="Download Images">
          <IconButton
            sx={{ backgroundColor: theme.palette.error.main }}
            onClick={() => downloadFilesAsync(asset)}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default AssetHeader;